<template>
  <div>
    <v-card class="my-6">
      <v-card-title class="align-start">
        <span class="font-weight-semibold text-base">Statistiques sur la période</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3" v-for="card in periodCards" :key="card.title">
            <div class="d-flex">
              <v-avatar size="44" :color="card.color" rounded class="elevation-1">
                <v-icon dark color="white" size="30">
                  {{ card.icon }}
                </v-icon>
              </v-avatar>
              <div class="ms-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-on="on"
                      v-bind="attrs"
                      class="text--secondary text-sm"
                      >{{ card.title }}</span
                    >
                  </template>
                  <span>{{ card.hoverTitle }}</span>
                </v-tooltip>
                <br />

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      class="text--primary text-xl font-weight-bold"
                      v-on="on"
                      v-bind="attrs"
                    >
                      {{ card.value }}
                    </span>
                  </template>
                  <span>{{ card.raw }}</span>
                </v-tooltip>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="my-6">
      <v-card-title class="align-start">
        <span class="font-weight-semibold text-base">Statistiques globales</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3" v-for="card in caCards" :key="card.title">
            <div class="d-flex">
              <v-avatar size="44" :color="card.color" rounded class="elevation-1">
                <v-icon dark color="white" size="30">
                  {{ card.icon }}
                </v-icon>
              </v-avatar>
              <div class="ms-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-on="on"
                      v-bind="attrs"
                      class="text--secondary text-sm"
                      >{{ card.title }}</span
                    >
                  </template>
                  <span>{{ card.hoverTitle }}</span>
                </v-tooltip>
                <br />

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      class="text--primary text-xl font-weight-bold"
                      v-on="on"
                      v-bind="attrs"
                    >
                      {{ card.value }}
                    </span>
                  </template>
                  <span>{{ card.raw }}</span>
                </v-tooltip>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3" v-for="card in sessionsCards" :key="card.title">
            <div class="d-flex">
              <v-avatar size="44" :color="card.color" rounded class="elevation-1">
                <v-icon dark color="white" size="30">
                  {{ card.icon }}
                </v-icon>
              </v-avatar>
              <div class="ms-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-on="on"
                      v-bind="attrs"
                      class="text--secondary text-sm"
                      >{{ card.title }}</span
                    >
                  </template>
                  <span>{{ card.hoverTitle }}</span>
                </v-tooltip>
                <br />

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      class="text--primary text-xl font-weight-bold"
                      v-on="on"
                      v-bind="attrs"
                    >
                      {{ card.value }}
                    </span>
                  </template>
                  <span>{{ card.raw }}</span>
                </v-tooltip>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {
  mdiCurrencyEur,
  mdiCashMultiple,
  mdiSpeedometer,
} from "@mdi/js";
import {
  formatCurrencyCompact,
  formatCurrency,
  formatNumber,
  formatNumberCompact,
} from "@/utils/formatting";

export default {
  name: "GlobalStatsCard",
  props: {
    sites: {
      type: Array,
      default: () => [],
    },
    partnerViews: {
      type: Array,
      default: () => [],
    },
    month: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      icons: {
        mdiCurrencyEur,
        mdiCashMultiple,
        mdiSpeedometer,
      },
      periodCards: [],
      caCards: [],
      sessionsCards: [],
    };
  },
  created() {},
  methods: {
    updateCardsData() {
      this.periodCards = [
        {
          title: "CA",
          hoverTitle:
            "CA généré par les articles republiés sur la période sélectionnée",
          value: formatCurrencyCompact(this.globalData.ca_period),
          raw: formatCurrency(this.globalData.ca_period),
          icon: this.icons.mdiCurrencyEur,
          color: "#4caf50",
        },
        {
          title: "Sessions",
          hoverTitle:
            "Sessions générées par les articles republiés sur la période sélectionnée",
          value: formatNumberCompact(this.globalData.sessions_period),
          raw: formatNumber(this.globalData.sessions_period),
          icon: this.icons.mdiSpeedometer,
          color: "#4caf50",
        },
      ];

      this.caCards = [
        {
          title: "CA total",
          hoverTitle:
            "CA total généré sur la période par les articles republiés (= avant + après republication)",
          value: formatCurrencyCompact(this.globalData.ca),
          raw: formatCurrency(this.globalData.ca),
          icon: this.icons.mdiCurrencyEur,
          color: "#fb9e0b",
        },
        {
          title: "CA avant republication",
          hoverTitle: "CA réalisé avant que les articles aient été republiés",
          value: formatCurrencyCompact(this.globalData.ca_before),
          raw: formatCurrency(this.globalData.ca_before),
          icon: this.icons.mdiCashMultiple,
          color: "#fb9e0b",
        },
        {
          title: "CA après republication",
          hoverTitle: "CA réalisé après que les articles aient été republiés",
          value: formatCurrencyCompact(this.globalData.ca_after),
          raw: formatCurrency(this.globalData.ca_after),
          icon: this.icons.mdiCashMultiple,
          color: "#fb9e0b",
        },
      ];

      this.sessionsCards = [
        {
          title: "Sessions totales",
          hoverTitle:
            "Sessions totales générées sur la période par les articles republiés (= avant + après republication)",
          value: formatNumberCompact(this.globalData.sessions),
          raw: formatNumber(this.globalData.sessions),
          icon: this.icons.mdiSpeedometer,
          color: "#444eff",
        },
        {
          title: "Sessions avant republication",
          hoverTitle:
            "Sessions réalisées avant que les articles aient été republiés",
          value: formatNumberCompact(this.globalData.sessions_before),
          raw: formatNumber(this.globalData.sessions_before),
          icon: this.icons.mdiSpeedometer,
          color: "#444eff",
        },
        {
          title: "Sessions après republication",
          hoverTitle:
            "Sessions réalisées après que les articles aient été republiés",
          value: formatNumberCompact(this.globalData.sessions_after),
          raw: formatNumber(this.globalData.sessions_after),
          icon: this.icons.mdiSpeedometer,
          color: "#444eff",
        },
      ];
    },
  },
  computed: {
    globalData() {
      return this.$store.getters["gd/getGlobalData"];
    },
  },
  watch: {
    globalData() {
      this.updateCardsData();
    },
  },
};
</script>

<style scoped></style>
